<template>
  <div>
    <v-row align="start" class="py-0">
      <v-col cols="12" class="pb-0">
        <v-banner icon="mdi-map-marker">
          Delivery Address
          <template v-slot:actions>
            <v-btn text color="blue darken-2" exact @click="$router.go(-1)">
              <v-icon left>arrow_back</v-icon>Back
            </v-btn>
          </template>
        </v-banner>
      </v-col>
    </v-row>
    <v-row align="start">
      <v-col cols="12">
        <DeliveryAddressForm
          ref="deliveryAddressForm"
          :isNew="this.$route.params.isNew"
          :data="this.$route.params.data"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import DeliveryAddressForm from "@/components/deliveryAddresses/Form.vue";

export default {
  components: {
    DeliveryAddressForm,
  },

  activated() {
    console.log("== PARAMS ==");
    console.log(this.$route.params);
    if (this.$route.params.isNew == false) {
      this.$refs.deliveryAddressForm.setData();
    } else {
      this.$refs.deliveryAddressForm.resetForm();
    }
  },
};
</script>

<style lang="sass" scoped>
</style>